module.exports = __webpack_public_path__ + "static/media/h_col1.584c95ce.png";